import { PopUpStore } from "./PopUpStore";

export const PopUpSelectors = {
    getPopUp: PopUpStore.selectorGetPopUp,
};

export const popUpReducer = PopUpStore.reducer;